// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yVnK","rootNoMargin":"styles_rootNoMargin__1DDbL"};